import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowFitBottomLeft16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconArrowFitBottomLeft16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7.69 2.501a.5.5 0 0 1 .5-.5H14V7.81h-1V3.708l-9.292 9.29h6.757a.5.5 0 0 1 0 1H3.501a1.5 1.5 0 0 1-1.5-1.5V5.535a.5.5 0 1 1 1 0v6.758L12.293 3H8.19a.5.5 0 0 1-.5-.5m5.81 5.31h.5a.5.5 0 1 1-1 0z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowFitBottomLeft16);
